// Makeup Studio "Look" presets (right panel)
// These are standalone prompt-based looks (NOT tied to the left preset/intensity system).

export const makeupStudioLooks = [
  {
    id: 'natural-no-makeup',
    name: 'Natural',
    previewImage: '/assets/makeup/natural_look_makeup.jpeg',
    prompt: "Natural 'no-makeup' makeup look focusing on dewy, radiant skin. Sheer, lightweight foundation with a fresh, glowing finish. Soft, diffused peach cream blush on the apples of the cheeks. Brows are naturally groomed and lightly filled with a clear gel. Eyelids have a sheer wash of warm beige cream shadow with a subtle sheen, and lashes are curled with one coat of lengthening mascara. Lips are hydrated with a glossy, sheer pink-nude balm."
  },
  {
    id: 'soft-glam',
    name: 'Soft glam',
    previewImage: '/assets/makeup/soft_glam_makeup.jpeg',
    prompt:
      "Soft glam makeup look with flawless, medium-to-full coverage skin and a natural matte finish. Features softly arched, filled-in brows, warm-toned brown and bronze blended eyeshadows concentrated in the crease and outer corner, subtle brown eyeliner, and lengthening false lashes. Cheeks have a soft peach-pink blush and subtle warm contour, and lips are finished with a matte dusty rose lipstick."
  },
  {
    id: 'old-hollywood-glam',
    name: 'Old Hollywood',
    previewImage: '/assets/makeup/old_hollywood_glam.jpeg',
    prompt:
      "Old Hollywood glam makeup look featuring flawless, full-coverage matte foundation. Brows are precisely groomed, arched, and defined. Eyes are highlighted with a neutral matte beige eyeshadow, a sharp, dramatic black winged eyeliner, and voluminous false lashes. Cheeks have a subtle, matte contour. Lips are painted with a bold, matte red lipstick."
  },
  {
    id: 'smokey-eye',
    name: 'Smokey Eye',
    previewImage: '/assets/makeup/smokey_eye_makeup.jpeg',
    prompt:
      "A dramatic, deep smokey eye makeup look featuring intense matte black and charcoal eyeshadow blown out through the crease and under the lower lash line, with tight-lined black kohl on the waterline. Voluminous, long false lashes are applied. The brows are bold, dark, and perfectly defined. The skin is flawless, full-coverage matte with subtle contouring on the cheekbones and nose. Lips are a matte, cool-toned nude shade."
  },
  {
    id: 'bridal-makeup',
    name: 'Bridal',
    previewImage: '/assets/makeup/bridal_makeup.jpeg',
    prompt:
      "A bridal makeup look with flawless, radiant skin. Features soft, warm neutral eyeshadows with a gentle shimmer on the lids, thin winged eyeliner, and fluttery, natural-looking false lashes. Cheeks are adorned with a soft peach-pink blush and subtle highlight, while lips are finished with a muted, matte rose lipstick. Brows are naturally groomed and defined."
  },
  {
    id: 'editorial-makeup',
    name: 'Editorial',
    previewImage: '/assets/makeup/editorial.jpeg',
    prompt:
      "An editorial makeup look featuring bold, geometric eye makeup with layered graphic shapes in blue, orange, yellow, and purple, defined by sharp black eyeliner. The brows are thick, dark, and arched. Cheeks have angular red and black color blocks. The lips are painted with a graphic, geometric pattern in white and black."
  },
  {
    id: 'monochromatic-makeup',
    name: 'Monochromatic',
    previewImage: '/assets/makeup/monochromatic.jpeg',
    prompt:
      "A monochromatic makeup look with a warm, earthy brown palette. The skin has a flawless, radiant base with a natural finish. Cheeks are defined with a warm terracotta blush applied high on the cheekbones. The eyes feature a soft, diffused wash of warm brown eyeshadow across the lid and into the crease, with defined, natural brows. Lips are painted with a matte, warm brown lipstick that complements the overall color scheme."
  },
  {
    id: 'artistic-makeup',
    name: 'Artistic',
    previewImage: '/assets/makeup/artistic.jpeg',
    prompt:
      "A vibrant, artistic makeup look featuring bold, graphic eyes. The eyelids have a gradient blend of electric blue and fuchsia pink eyeshadow, defined by a sharp, double-winged graphic liner in black and white with a cut-crease effect. Blue mascara coats the upper and lower lashes. The brows are bold, dark, and structured. The skin is flawless with a matte finish, and the lips are painted with a striking matte orange lipstick."
  },
  {
    id: 'glitter-makeup',
    name: 'Glitter',
    previewImage: '/assets/makeup/glitter.jpeg',
    prompt:
      "A radiant, dewy artistic makeup look. The skin is luminous with a high-shine finish, particularly on the cheekbones, bridge of the nose, and cupid's bow. The eyelids are covered in a sparkling, glittery champagne gold eyeshadow that catches the light, paired with a thin black eyeliner and defined lashes. The brows are naturally groomed. The lips are coated in a clear, high-shine gloss."
  },

];

